




























import CommonButton from '@/components/button/CommonButton.vue';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';

import Component from 'vue-class-component';
import {Mixins} from 'vue-property-decorator';
import {SubmissionConfirmDialogRequest} from '@/model/CommonModel';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import '@/plugins/Modal';
import TextInput from '@/components/input/TextInput.vue';

@Component({
  components: {
    CommonButton,
    CommonPromptDialog,
    TextInput
  },
  mixins: [DialogEventsMixin],
})
export default class SubmissionConfirmDialog extends Mixins<DialogEventsMixin>(DialogEventsMixin) {
  private comments: string = '';
  private dialogVisible: boolean = false;
  private off: () => void;

  private cases: number = 0;
  private onConfirm: ((comments: string, hide: () => void) => void) | undefined;

  get isVisible() {
    return this.dialogVisible;
  }

  public mounted() {
    this.$modal
        .getEventBus()
        .$on('showSubmissionConfirmDialog', (params: SubmissionConfirmDialogRequest) => {
          this.show(params);
        });

    this.$modal.getEventBus().$on('hideSubmissionConfirmDialog', () => this.cancel());
  }

  public onOpened() {
    const refs = (this.$refs.comments as any);
    if (refs && refs.focus instanceof Function) {
      refs.focus(100);
    }
  }

  public show(params: SubmissionConfirmDialogRequest) {
    this.dialogVisible = true;
    const {cases, onConfirm} = params;
    this.cases = cases;
    this.onConfirm = onConfirm;
  }

  public confirm(param: any) {
    const {$event, on, off} = param;
    if (this.onConfirm instanceof Function) {
      on();
      this.off = off;
      this.onConfirm(this.comments, this.hide);
    } else {
      this.hide();
    }
  }

  public cancel() {
    this.hide();
  }

  public hide() {
    this.dialogVisible = false;
  }

  public onClosed() {
    this.comments = '';
    if (this.off) {
      this.off();
    }
  }

  public destroyed() {
    this.$modal.getEventBus().$off('showSubmissionConfirmDialog');
    this.$modal.getEventBus().$off('hideSubmissionConfirmDialog');
  }
}
